
export class DatasetsDto {
  datasetReferences: DatasetReferenceDto[]
}

export class DatasetReferenceDto {
  datasetReferenceTable: DatasetReferenceTable;
  dataTableSchemas: DataTableSchema[];
}

export class Dataset {
  datasetReferenceTable: DatasetReferenceTable;
  dataTableSchemas: DataTableSchema[];


  constructor(datasetReferenceTable?: DatasetReferenceTable, dataTableSchemas?: DataTableSchema[]) {
     // Use default values if no arguments are passed
    this.datasetReferenceTable = datasetReferenceTable || new DatasetReferenceTable();
    this.dataTableSchemas = dataTableSchemas || [];

  }

}

export class DatasetReferenceTable {
    applicationId: number = 0;
    datasetId: number = 0;
    datasetName: string = "";
    internalTableIdentifier: string = "";
    primaryKey: string = "";
    datasetType: DatasetType;
    datasetStructure: DatasetStructure;
    tags: string = "";
    allowedViewRoles: string[] = [];
    allowedEditRoles: string[] = [];
    allowedViewEmails: string[] = [];
    allowedEditEmails: string[] = [];
    integrationId: number = 0;

    constructor() {
    }
}

export enum DatasetType {
  Master = 'Master',
  Reference = 'Reference',
  View = 'View',
}

export enum DatasetStructure {
  Flat = "Flat",
  Hierarchy = "Hierarchy"
}

export class DatasetIdRequest {
  datasetId: number;

  constructor(datasetId: number) {
      this.datasetId = datasetId;
  }
}

export class CopyDatasetDto {
  public applicationId: number;
  public sourceDatasetId: number;
  public newDatasetName: string;
}

export interface ExtractValueColumn {
  name: string;
}

export interface ExtractFieldGroupRow {
  sourceFieldIds: number[];
}

export interface ExtractFieldGroup {
  categoryValue: string;
  rows: ExtractFieldGroupRow[];
}

export interface ExtractKeyField {
  fieldId: number;
  newName?: string; // Optional rename — if omitted, the original field name is kept
}

export class ExtractDatasetDto {
  public applicationId: number;
  public sourceDatasetId: number;
  public newDatasetName: string;
  public keyFields: ExtractKeyField[];
  public categoryColumnName: string;
  public valueColumns: ExtractValueColumn[];
  public fieldGroups: ExtractFieldGroup[];
  public skipNulls: boolean = true;
}

export class DataTableSchemaResponse {
    datasetId: number;
    dataTableSchemas: DataTableSchema[];
}

export class DataTableSchema {
    fieldId: number;
    applicationId: number;
    datasetId: number;
    fieldName: string;
    displayName: string;
    dataType: DataSchemaDataType;
    isNullable: boolean;
    isPrimaryKey: boolean;
    defaultValue: string;
    autoIncrement: boolean;
    referenceDataId: number;
    referenceFieldId: number | null;
    fieldToDisplay: string;
    description: string;
    fieldFormat: string;
    units: string;
    isHidden: boolean;
    ordinal: number;
    isFileStorageReference: boolean;
}

export enum DataSchemaDataType {
  String = "String",
  Decimal = "Decimal",
  DateTime = "DateTime",
  Boolean = "Boolean",
  Integer =  "Integer"
}



export enum FixedFields {
  ParentKey = 'ParentKey',
  HiddenInternalPrimaryKey = 'Hidden_Internal_PrimaryKey',
}

export const FILE_STORAGE_IDENTIFIER = '📁 File Storage';
export const FILE_STORAGE_REFERENCE_ID = -1;
